import React, { useState, useEffect, useContext } from 'react';
import ReactDOM from 'react-dom';
import { useAuthStore } from '../../store/auth';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { CartContext } from '../../App';
import { HiOutlineShoppingCart } from 'react-icons/hi';
import { FiMenu, FiX, FiUser, FiHeart, FiBell, FiSettings, FiSearch, FiHome, FiFolder, FiZap, FiInfo, FiPhone, FiClipboard, FiLogOut } from 'react-icons/fi';
import apiInstance from '../../utils/axios';
import Logo from "../../../public/logo_v2.png"
// import LanguageSwitcher from '../../components/LanguageSwitcher';
// import { useLanguage } from '../../contexts/LanguageContext';
import PriceFormat_Basic from '@/components/commerce-ui/price-format-basic';


function StoreHeader() {
  const [isLoggedIn, user] = useAuthStore((state) => [state.isLoggedIn, state.user]);
  const [cartCount] = useContext(CartContext);
  const [search, setSearch] = useState('');
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState(null);
  const [categoryProducts, setCategoryProducts] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isSmallMobile, setIsSmallMobile] = useState(window.innerWidth <= 480);
  const [storeInfo, setStoreInfo] = useState({
    phones: ['+595 981 123456'],
    emails: ['contacto@herramientastayrun.com.py'],
    facebook: null,
    instagram: null,
    twitter: null
  });

  const navigate = useNavigate();
  // Eliminado: const { t } = useLanguage();

  // Fetch store info from API
  useEffect(() => {
    const fetchStoreInfo = async () => {
      try {
        const response = await apiInstance.get('store-info/');
        setStoreInfo(response.data);
      } catch (error) {
        console.log('Using default store info');
      }
    };
    fetchStoreInfo();
  }, []);

  // Close mobile menu on route change
  const location = useLocation();
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  // Handle responsive breakpoints
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsSmallMobile(window.innerWidth <= 480);
    };

    handleResize(); // Set initial state
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch categories from the API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiInstance.get('category/');
        const categoriesData = Array.isArray(response.data) ? response.data : (response.data.results || []);
        setCategories(categoriesData);
        setLoading(false);
      } catch (error) {
        console.error('❌ StoreHeader: Error fetching categories:', error);
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // Fetch products for a specific category when hovered
  const fetchCategoryProducts = async (categoryId) => {
    if (categoryProducts[categoryId]) return; // Already fetched
    
    try {
      const response = await apiInstance.get(`products/?category=${categoryId}`);
      // Handle both direct array and paginated response
      const productsData = Array.isArray(response.data) ? response.data : (response.data.results || []);
      setCategoryProducts(prev => ({
        ...prev,
        [categoryId]: productsData.slice(0, 4) // Get first 4 products
      }));
    } catch (error) {
      console.error('Error fetching category products:', error);
    }
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
  };

  const handleSearchSubmit = () => {
    if (search.trim()) {
      navigate(`/search?query=${encodeURIComponent(search.trim())}`);
      setIsMobileSearchOpen(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchSubmit();
    }
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  const toggleMobileSearch = () => {
    setIsMobileSearchOpen(!isMobileSearchOpen);
  };



  const handleCategoryHover = (category) => {
    setHoveredCategory(category);
    if (category) {
      fetchCategoryProducts(category.id);
    }
  };

  return (
    <header style={{ backgroundColor: '#ffffff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', position: 'sticky', top: 0, zIndex: 1000 }}>
      {/* Top Bar - Hidden on mobile */}
      <div style={{ 
        backgroundColor: '#1f2937', 
        color: 'white', 
        padding: '8px 0', 
        fontSize: '14px',
        display: isMobile ? 'none' : 'block'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <span>📞 {storeInfo.phones?.[0] || '+595 981 123456'}</span>
            <span>📧 {storeInfo.emails?.[0] || 'contacto@herramientastayrun.com.py'}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span style={{ fontSize: '12px' }}>Seguinos</span>
            <div style={{ display: 'flex', gap: '10px' }}>
              {storeInfo.facebook && (
                <a href={storeInfo.facebook} target="_blank" rel="noopener noreferrer" style={{ color: 'white', fontSize: '16px' }}>
                  <i className="fab fa-facebook-f"></i>
                </a>
              )}
              {storeInfo.instagram && (
                <a href={storeInfo.instagram} target="_blank" rel="noopener noreferrer" style={{ color: 'white', fontSize: '16px' }}>
                  <i className="fab fa-instagram"></i>
                </a>
              )}
              {storeInfo.twitter && (
                <a href={storeInfo.twitter} target="_blank" rel="noopener noreferrer" style={{ color: 'white', fontSize: '16px' }}>
                  <i className="fab fa-twitter"></i>
                </a>
              )}
              {!storeInfo.facebook && !storeInfo.instagram && !storeInfo.twitter && (
                <>
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: 'white', fontSize: '16px' }}>
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: 'white', fontSize: '16px' }}>
                    <i className="fab fa-instagram"></i>
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: isMobile ? '8px 12px' : '18px 20px' }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          gap: isMobile ? '8px' : '20px',
          minHeight: isMobile ? '56px' : '64px',
          height: isMobile ? '56px' : '64px',
        }}>
          
          {/* Mobile Menu Toggle */}
          {isMobile && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                toggleMobileMenu();
              }}
              style={{
                display: 'flex',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1001,
                position: 'relative',
                marginRight: '8px',
                minWidth: '44px',
                minHeight: '44px',
                borderRadius: '8px',
                backgroundColor: 'rgba(0,0,0,0.05)',
                touchAction: 'manipulation',
              }}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
          )}

          {/* Logo */}
          <Link
            to="/"
            style={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
              color: '#1f2937',
              fontSize: isMobile ? '16px' : '28px',
              fontWeight: 'bold',
              fontFamily: 'Arial, Helvetica, sans-serif',
              flex: isMobile ? '1' : 'none',
              overflow: 'visible',
            }}
          >
          <img
            src={Logo}
            alt="Logo de Herramientas Tayrun"
            style={{
              height: isSmallMobile ? '63px' : (isMobile ? '71px' : '90px'),
              width: 'auto',
              maxWidth: '100%',
              objectFit: 'contain',
              marginLeft: isMobile ? '8px' : '0',
              marginRight: isMobile ? '0' : '16px',
            }}
          />
            {/* {window.innerWidth > 480 && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                lineHeight: '1.1',
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              }}>
                <span style={{
                  fontSize: window.innerWidth <= 768 ? '18px' : '24px',
                  fontWeight: '700',
                  color: '#1a365d',
                  letterSpacing: '-0.02em',
                  textShadow: '0 1px 2px rgba(0,0,0,0.1)',
                }}>
                  Mundo Das
                </span>
                <span style={{
                  fontSize: window.innerWidth <= 768 ? '16px' : '20px',
                  fontWeight: '600',
                  color: '#2d3748',
                  letterSpacing: '-0.01em',
                  marginTop: '-2px',
                }}>
                  Ferramentas
                </span>
              </div>
            )} */}
          </Link>

          {/* Desktop Search Bar */}
          <div style={{ 
            flex: 1, 
            maxWidth: '600px', 
            margin: '0 20px',
            display: isMobile ? 'none' : 'block'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#f8fafc',
              borderRadius: '12px',
              padding: '12px 16px',
              border: '2px solid #e2e8f0',
              transition: 'all 0.2s ease',
            }}>
              <input
                type="text"
                placeholder="Buscar productos, marcas, categorías..."
                value={search}
                onChange={handleSearchChange}
                onKeyDown={handleKeyDown}
                style={{
                  border: 'none',
                  outline: 'none',
                  flex: 1,
                  backgroundColor: 'transparent',
                  color: '#1f2937',
                  fontSize: '16px',
                  fontWeight: '400',
                  minWidth: '0',
                  width: '100%',
                  pointerEvents: 'auto',
                  cursor: 'text',
                }}
                onClick={(e) => e.stopPropagation()}
              />
              <button
                onClick={handleSearchSubmit}
                style={{
                  background: '#3b82f6',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '8px 16px',
                  color: 'white',
                  cursor: 'pointer',
                  transition: 'background-color 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                <FiSearch size={16} />
                Buscar
              </button>
            </div>
          </div>

          {/* Right Side Actions */}
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: isMobile ? '4px' : '16px' 
          }}>
            
            {/* Mobile Search Toggle */}
            <button
              onClick={toggleMobileSearch}
              style={{
                display: isMobile ? 'flex' : 'none',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '6px',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '40px',
                minHeight: '40px',
                borderRadius: '8px',
              }}
            >
              <FiSearch size={18} />
            </button>

            {/* Language Switcher - Hidden on small mobile */}
              {/* Language Switcher eliminado */}
            
            {/* User Account */}
            <div style={{ position: 'relative' }}>
              {isLoggedIn() ? (
                <div>
                  <button
                    onClick={toggleUserMenu}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: isMobile ? '2px' : '8px',
                      padding: isMobile ? '6px' : '8px 12px',
                      borderRadius: '8px',
                      transition: 'background-color 0.2s ease',
                      minWidth: isMobile ? '40px' : 'auto',
                      minHeight: isMobile ? '40px' : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <FiUser size={isMobile ? 18 : 20} color="#374151" />
                    {!isMobile && (
                      <span style={{ color: '#374151', fontSize: '14px', fontWeight: '500' }}>
                        {user()?.username || 'Cuenta'}
                      </span>
                    )}
                  </button>
                  
                  {/* User Dropdown Menu */}
                  {isUserMenuOpen && (
                    <div style={{
                      position: 'absolute',
                      top: '100%',
                      right: 0,
                      backgroundColor: 'white',
                      borderRadius: '12px',
                      boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                      border: '1px solid #e2e8f0',
                      minWidth: isMobile ? '200px' : '220px',
                      zIndex: 1000,
                      marginTop: '8px',
                    }}>
                      <div style={{ padding: '12px 16px', borderBottom: '1px solid #e2e8f0' }}>
                        <div style={{ fontSize: '14px', fontWeight: '600', color: '#1f2937' }}>
                          {user()?.username}
                        </div>
                        <div style={{ fontSize: '12px', color: '#6b7280' }}>
                          {user()?.email}
                        </div>
                      </div>
                      
                      <div style={{ padding: '8px 0' }}>
                        <Link
                          to="/customer/account/"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '12px 16px',
                            color: '#374151',
                            textDecoration: 'none',
                            fontSize: '14px',
                            transition: 'background-color 0.2s ease',
                          }}
                        >
                          <FiUser size={16} />
                          Mi cuenta
                        </Link>
                        
                        <Link
                          to="/customer/orders/"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '12px 16px',
                            color: '#374151',
                            textDecoration: 'none',
                            fontSize: '14px',
                            transition: 'background-color 0.2s ease',
                          }}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
                          </svg>
                          Pedidos
                        </Link>
                        
                        <Link
                          to="/customer/wishlist/"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '12px 16px',
                            color: '#374151',
                            textDecoration: 'none',
                            fontSize: '14px',
                            transition: 'background-color 0.2s ease',
                          }}
                        >
                          <FiHeart size={16} />
                          Favoritos
                        </Link>
                        
                        <div style={{ height: '1px', backgroundColor: '#e2e8f0', margin: '8px 0' }}></div>
                        
                        <Link
                          to="/logout"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '12px 16px',
                            color: '#ef4444',
                            textDecoration: 'none',
                            fontSize: '14px',
                            transition: 'background-color 0.2s ease',
                          }}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                            <polyline points="16,17 21,12 16,7"></polyline>
                            <line x1="21" y1="12" x2="9" y2="12"></line>
                          </svg>
                          Cerrar sesión
                        </Link>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ 
                  display: 'flex', 
                  gap: isMobile ? '4px' : '12px',
                  flexDirection: 'row'
                }}>
                  <button
                    onClick={() => window.location.href = '/login'}
                    style={{
                      padding: isMobile ? '6px 10px' : '8px 16px',
                      backgroundColor: 'transparent',
                      color: '#374151',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      textDecoration: 'none',
                      fontSize: isMobile ? '11px' : '14px',
                      fontWeight: '500',
                      transition: 'all 0.2s ease',
                      textAlign: 'center',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                      minHeight: '40px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {isSmallMobile ? <FiUser size={16} /> : 'Mi cuenta'}
                  </button>
                </div>
              )}
            </div>

            {/* Cart */}
            <button
              onClick={() => {
                setIsMobileMenuOpen(false);
                setIsUserMenuOpen(false);
                navigate('/cart/');
              }}
              style={{
                position: 'relative',
                padding: isMobile ? '6px' : '12px',
                backgroundColor: '#f8fafc',
                borderRadius: '10px',
                border: '1px solid #e2e8f0',
                color: '#374151',
                cursor: 'pointer',
                minWidth: isMobile ? '40px' : 'auto',
                minHeight: isMobile ? '40px' : 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <HiOutlineShoppingCart size={isMobile ? 18 : 24} />
              {cartCount > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '-6px',
                  right: '-6px',
                  backgroundColor: '#ef4444',
                  color: 'white',
                  borderRadius: '50%',
                  padding: '4px 8px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  minWidth: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '2px solid white',
                }}>
                  {cartCount}
                </span>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Search Bar */}
      {isMobileSearchOpen && (
        <div style={{
          padding: '16px 20px',
          backgroundColor: '#f8fafc',
          borderTop: '1px solid #e2e8f0',
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '12px 16px',
            border: '2px solid #e2e8f0',
          }}>
              <input
                type="text"
                placeholder="Buscar productos, marcas, categorías..."
                value={search}
                onChange={handleSearchChange}
                onKeyDown={handleKeyDown}
                className="mobile-search-input"
                style={{
                  border: 'none',
                  outline: 'none',
                  flex: 1,
                  backgroundColor: 'transparent',
                  color: '#1f2937',
                  fontSize: '16px',
                  fontWeight: '400',
                  minWidth: '0',
                  width: '100%',
                }}
                autoFocus
              />
            <button
              onClick={handleSearchSubmit}
              style={{
                background: '#3b82f6',
                border: 'none',
                borderRadius: '8px',
                padding: '8px 12px',
                color: 'white',
                cursor: 'pointer',
                marginLeft: '8px',
              }}
            >
              <FiSearch size={16} />
            </button>
          </div>
        </div>
      )}

      {/* Desktop Navigation Bar */}
      <nav style={{
        backgroundColor: '#1f2937',
        borderTop: '1px solid #374151',
        display: isMobile ? 'none' : 'block'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '40px',
            padding: '16px 0',
          }}>
            
            {/* Home Link */}
            <Link
              to="/"
              style={{
                color: 'rgba(255, 255, 255, 0.9)',
                textDecoration: 'none',
                fontSize: '16px',
                fontWeight: '500',
                padding: '8px 16px',
                borderRadius: '8px',
                transition: 'all 0.2s ease',
              }}
            >
              Inicio
            </Link>

            {/* Categories Dropdown */}
            <div 
              style={{ position: 'relative', display: 'inline-block' }}
              onMouseEnter={() => {
                clearTimeout(window.categoryHideTimeout);
                setHoveredCategory({ id: 'dropdown', title: 'Categorías' });
              }}
              onMouseLeave={() => {
                window.categoryHideTimeout = setTimeout(() => {
                  setHoveredCategory(null);
                }, 300);
              }}
            >
              <Link
                to="/products"
                style={{
                  color: 'rgba(255, 255, 255, 0.9)',
                  textDecoration: 'none',
                  fontSize: '16px',
                  fontWeight: '500',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  transition: 'all 0.2s ease',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                Categorías
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="6,9 12,15 18,9"></polyline>
                </svg>
              </Link>
              
              {/* Categories Dropdown Menu */}
              <div
                style={{
                  display: hoveredCategory !== null ? 'flex' : 'none',
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                  border: '1px solid #e2e8f0',
                  zIndex: 1000,
                  marginTop: '8px',
                  minWidth: '600px',
                  maxHeight: '400px',
                  opacity: hoveredCategory !== null ? 1 : 0,
                  transform: hoveredCategory !== null ? 'translateY(0)' : 'translateY(-10px)',
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                {/* Categories List */}
                <div style={{ 
                  width: '250px', 
                  borderRight: '1px solid #e2e8f0',
                  padding: '12px 0'
                }}>
                  <Link
                    to="/products"
                    style={{
                      display: 'block',
                      padding: '12px 20px',
                      color: '#374151',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: '600',
                      borderBottom: '1px solid #e2e8f0',
                      transition: 'background-color 0.2s ease',
                    }}
                  >
                    Todos los productos
                  </Link>
                  
                  {loading ? (
                    <div style={{ padding: '12px 20px', color: '#6b7280', fontSize: '14px' }}>
                      Cargando...
                    </div>
                  ) : !Array.isArray(categories) || categories.length === 0 ? (
                    <div style={{ padding: '12px 20px', color: '#6b7280', fontSize: '14px' }}>
                      Sin categorías
                    </div>
                  ) : (
                    categories.slice(0, 8).map((category) => (
                      <Link
                        key={category.id}
                        to={`/products?category=${category.id}`}
                        style={{
                          display: 'block',
                          padding: '12px 20px',
                          color: '#374151',
                          textDecoration: 'none',
                          fontSize: '14px',
                          transition: 'background-color 0.2s ease',
                          backgroundColor: hoveredCategory?.id === category.id ? '#f8fafc' : 'transparent',
                        }}
                        onMouseEnter={() => {
                          clearTimeout(window.categoryHideTimeout);
                          handleCategoryHover(category);
                        }}
                      >
                        {category.title_translated || category.title}
                      </Link>
                    ))
                  )}
                </div>

                {/* Category Preview */}
                <div style={{ 
                  flex: 1, 
                  padding: '20px',
                  minHeight: '200px'
                }}>
                  {hoveredCategory && hoveredCategory.id !== 'all' ? (
                    <div>
                      <h3 style={{ 
                        fontSize: '18px', 
                        fontWeight: '600', 
                        color: '#1f2937',
                        marginBottom: '16px'
                      }}>
                        {hoveredCategory.title_translated || hoveredCategory.title}
                      </h3>
                      
                      {categoryProducts[hoveredCategory.id] ? (
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(2, 1fr)',
                          gap: '12px'
                        }}>
                          {categoryProducts[hoveredCategory.id].map((product) => (
                            <Link
                              key={product.id}
                              to={`/detail/${product.slug}/`}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                padding: '8px',
                                borderRadius: '8px',
                                textDecoration: 'none',
                                color: '#374151',
                                transition: 'background-color 0.2s ease',
                              }}
                            >
                              <img
                                src={product.image}
                                alt={product.title_translated || product.title}
                                style={{
                                  width: '50px',
                                  height: '50px',
                                  objectFit: 'cover',
                                  borderRadius: '6px',
                                  border: '1px solid #e2e8f0'
                                }}
                              />
                              <div style={{ flex: 1 }}>
                                <div style={{
                                  fontSize: '13px',
                                  fontWeight: '500',
                                  color: '#1f2937',
                                  marginBottom: '2px',
                                  lineHeight: '1.3'
                                }}>
                                  {(product.title_translated || product.title).length > 30 ? 
                                    (product.title_translated || product.title).substring(0, 30) + '...' : 
                                    (product.title_translated || product.title)
                                  }
                                </div>
                                <div style={{
                                  fontSize: '12px',
                                  color: '#3b82f6',
                                  fontWeight: '600'
                                }}>
                                  <PriceFormat_Basic value={product.price} />
                                </div>
                              </div>
                            </Link>
                          ))}
                        </div>
                      ) : (
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '120px',
                          color: '#6b7280',
                          fontSize: '14px'
                        }}>
                          Cargando productos...
                        </div>
                      )}
                      
                      <Link
                        to={`/products?category=${hoveredCategory.id}`}
                        style={{
                          display: 'inline-block',
                          marginTop: '16px',
                          padding: '8px 16px',
                          backgroundColor: '#3b82f6',
                          color: 'white',
                          textDecoration: 'none',
                          borderRadius: '6px',
                          fontSize: '13px',
                          fontWeight: '500',
                          transition: 'background-color 0.2s ease',
                        }}
                      >
                        Ver todo {hoveredCategory.title_translated || hoveredCategory.title}
                      </Link>
                    </div>
                  ) : (
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: '120px',
                      color: '#6b7280',
                      fontSize: '14px'
                    }}>
                      Pasá el mouse por una categoría
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Other navigation links */}
            <Link to="/products?promotion=true" style={{ color: 'rgba(255, 255, 255, 0.9)', textDecoration: 'none', fontSize: '16px', fontWeight: '500', padding: '8px 16px', borderRadius: '8px', transition: 'all 0.2s ease', position: 'relative' }}>
              Promociones
              <span style={{ position: 'absolute', top: '-4px', right: '-4px', backgroundColor: '#ef4444', color: 'white', fontSize: '10px', padding: '2px 6px', borderRadius: '12px', fontWeight: 'bold' }}>
                ¡Nuevo!
              </span>
            </Link>

            <Link to="/about" style={{ color: 'rgba(255, 255, 255, 0.9)', textDecoration: 'none', fontSize: '16px', fontWeight: '500', padding: '8px 16px', borderRadius: '8px', transition: 'all 0.2s ease' }}>
              Sobre nosotros
            </Link>

            <Link to="/contact" style={{ color: 'rgba(255, 255, 255, 0.9)', textDecoration: 'none', fontSize: '16px', fontWeight: '500', padding: '8px 16px', borderRadius: '8px', transition: 'all 0.2s ease' }}>
              Contacto
            </Link>
          </div>
        </div>
      </nav>

      {/* Mobile Menu - Rendered as Portal to body for full screen overlay */}
      {isMobileMenuOpen && ReactDOM.createPortal(
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 99999,
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setIsMobileMenuOpen(false);
            }
          }}
        >
          <div style={{
            position: 'fixed',
            top: 0,
            right: 0,
            width: isSmallMobile ? '100%' : '300px',
            height: '100vh',
            backgroundColor: 'white',
            padding: '20px',
            overflowY: 'auto',
            boxShadow: '-4px 0 20px rgba(0,0,0,0.15)',
            animation: 'slideIn 0.3s ease-out',
          }}>
            <style>{`
              @keyframes slideIn {
                from { transform: translateX(100%); }
                to { transform: translateX(0); }
              }
            `}</style>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
              <h3 style={{ margin: 0, color: '#1f2937' }}>Menú</h3>
              <button
                onClick={toggleMobileMenu}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '8px',
                }}
              >
                <FiX size={24} />
              </button>
            </div>
            
            {/* Language Switcher in Mobile Menu */}
            {/* Language Switcher eliminado del menú móvil */}
            
            {/* Mobile menu items */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
              <Link 
                to="/" 
                onClick={() => setIsMobileMenuOpen(false)}
                style={{ 
                  color: '#374151', 
                  textDecoration: 'none', 
                  fontSize: '16px', 
                  padding: '16px 0',
                  borderBottom: '1px solid #f3f4f6',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px'
                }}
              >
                <FiHome size={18} style={{ color: '#6b7280' }} />
                Inicio
              </Link>
              
              <Link 
                to="/products" 
                onClick={() => setIsMobileMenuOpen(false)}
                style={{ 
                  color: '#374151', 
                  textDecoration: 'none', 
                  fontSize: '16px', 
                  padding: '16px 0',
                  borderBottom: '1px solid #f3f4f6',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px'
                }}
              >
                <FiFolder size={18} style={{ color: '#6b7280' }} />
                Categorías
              </Link>
              
              {/* Categories submenu */}
              <div style={{ paddingLeft: '20px', backgroundColor: '#f8fafc' }}>
                {categories.slice(0, 6).map((category) => (
                  <Link
                    key={category.id}
                    to={`/products?category=${category.id}`}
                    onClick={() => setIsMobileMenuOpen(false)}
                    style={{
                      display: 'block',
                      color: '#6b7280',
                      textDecoration: 'none',
                      fontSize: '14px',
                      padding: '12px 0',
                      borderBottom: '1px solid #f3f4f6',
                    }}
                  >
                    {category.title_translated || category.title}
                  </Link>
                ))}
              </div>
              
              <Link 
                to="/products?promotion=true" 
                onClick={() => setIsMobileMenuOpen(false)}
                style={{ 
                  color: '#374151', 
                  textDecoration: 'none', 
                  fontSize: '16px', 
                  padding: '16px 0',
                  borderBottom: '1px solid #f3f4f6',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px'
                }}
              >
                <FiZap size={18} style={{ color: '#f59e0b' }} />
                Promociones
              </Link>
              
              <Link 
                to="/about" 
                onClick={() => setIsMobileMenuOpen(false)}
                style={{ 
                  color: '#374151', 
                  textDecoration: 'none', 
                  fontSize: '16px', 
                  padding: '16px 0',
                  borderBottom: '1px solid #f3f4f6',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px'
                }}
              >
                <FiInfo size={18} style={{ color: '#6b7280' }} />
                Sobre nosotros
              </Link>
              
              <Link 
                to="/contact" 
                onClick={() => setIsMobileMenuOpen(false)}
                style={{ 
                  color: '#374151', 
                  textDecoration: 'none', 
                  fontSize: '16px', 
                  padding: '16px 0',
                  borderBottom: '1px solid #f3f4f6',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px'
                }}
              >
                <FiPhone size={18} style={{ color: '#6b7280' }} />
                Contacto
              </Link>

              {/* User account links for mobile */}
              {isLoggedIn() ? (
                <>
                  <Link 
                    to="/customer/account/" 
                    onClick={() => setIsMobileMenuOpen(false)}
                    style={{ 
                      color: '#374151', 
                      textDecoration: 'none', 
                      fontSize: '16px', 
                      padding: '16px 0',
                      borderBottom: '1px solid #f3f4f6',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px'
                    }}
                  >
                    <FiUser size={18} style={{ color: '#6b7280' }} />
                    Mi cuenta
                  </Link>
                  
                  <Link 
                    to="/customer/orders/" 
                    onClick={() => setIsMobileMenuOpen(false)}
                    style={{ 
                      color: '#374151', 
                      textDecoration: 'none', 
                      fontSize: '16px', 
                      padding: '16px 0',
                      borderBottom: '1px solid #f3f4f6',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px'
                    }}
                  >
                    <FiClipboard size={18} style={{ color: '#6b7280' }} />
                    Pedidos
                  </Link>
                  
                  <Link 
                    to="/customer/wishlist/" 
                    onClick={() => setIsMobileMenuOpen(false)}
                    style={{ 
                      color: '#374151', 
                      textDecoration: 'none', 
                      fontSize: '16px', 
                      padding: '16px 0',
                      borderBottom: '1px solid #f3f4f6',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px'
                    }}
                  >
                    <FiHeart size={18} style={{ color: '#ef4444' }} />
                    Favoritos
                  </Link>
                  
                  <Link 
                    to="/logout" 
                    onClick={() => setIsMobileMenuOpen(false)}
                    style={{ 
                      color: '#ef4444', 
                      textDecoration: 'none', 
                      fontSize: '16px', 
                      padding: '16px 0',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px'
                    }}
                  >
                    <FiLogOut size={18} style={{ color: '#ef4444' }} />
                    Cerrar sesión
                  </Link>
                </>
              ) : (
                <div style={{ padding: '16px 0', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  <button
                    onClick={() => {
                      setIsMobileMenuOpen(false);
                      window.location.href = '/login';
                    }}
                    style={{
                      padding: '12px 16px',
                      backgroundColor: 'transparent',
                      color: '#374151',
                      border: '1px solid #d1d5db',
                      borderRadius: '8px',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: '500',
                      textAlign: 'center',
                      cursor: 'pointer',
                      width: '100%'
                    }}
                  >
                    Mi cuenta
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* Click outside to close user menu */}
      {isUserMenuOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999,
          }}
          onClick={() => setIsUserMenuOpen(false)}
        />
      )}

      {/* Mobile-specific styles */}
      <style>{`
        @media (max-width: 768px) {
          .mobile-menu-toggle {
            display: block !important;
          }
          
          .search-bar {
            display: none !important;
          }
          
          .desktop-nav {
            display: none !important;
          }
        }

        @media (max-width: 480px) {
          .mobile-search-input {
            font-size: 16px !important; /* Prevents zoom on iOS */
          }
        }
      `}</style>


    </header>
  );
}

export default StoreHeader;

